import React, { useCallback, useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import SocketContext from "../../providers/Socket";
import Notifications from "./Notifications";
import useSearch from "../../hooks/use-search";
import { STATUS_CLICKED, STATUS_OPENED, STATUS_SEEN } from "../../constants/status";
import { getDataFromStorage } from "../../libs/auth.helper";
import MainContainer from "../MainContainer";
import useConfig from '../../hooks/use-config';
export var EnumNotificationStatus;
(function (EnumNotificationStatus) {
    EnumNotificationStatus[EnumNotificationStatus["CLICKED"] = 80] = "CLICKED";
    EnumNotificationStatus[EnumNotificationStatus["SEEN"] = 70] = "SEEN";
})(EnumNotificationStatus || (EnumNotificationStatus = {}));
const LIMIT_HISTORY = 30;
const HeaderComponent = ({ config, header: Header }) => {
    if (!Header)
        return React.createElement(React.Fragment, null);
    return React.createElement(Header, { states: config.states, actions: config.actions });
};
const DEFAULT_DELTA_DETAILS = {
    lower_id: -1,
    time: 0,
    upper_id: -1
};
const ReadStatus = [
    STATUS_SEEN, STATUS_OPENED, STATUS_CLICKED
];
var FilterReadEnum;
(function (FilterReadEnum) {
    FilterReadEnum[FilterReadEnum["All"] = -1] = "All";
    FilterReadEnum[FilterReadEnum["Read"] = 1] = "Read";
    FilterReadEnum[FilterReadEnum["UNREAD"] = 2] = "UNREAD";
})(FilterReadEnum || (FilterReadEnum = {}));
var FilterTapEnum;
(function (FilterTapEnum) {
    FilterTapEnum[FilterTapEnum["All"] = -1] = "All";
    FilterTapEnum[FilterTapEnum["MyAds"] = 1] = "MyAds";
    FilterTapEnum[FilterTapEnum["OtherAds"] = 2] = "OtherAds";
})(FilterTapEnum || (FilterTapEnum = {}));
const DEFAULT_FILTER = {
    read: FilterReadEnum.All,
    tap: FilterTapEnum.All
};
const NotificationsPage = (props) => {
    var _a;
    const { socket, initialNotification } = useContext(SocketContext);
    const [hasMore, setHasMore] = useState(true);
    const [tap, setTap] = useState(1);
    const [readableFilter, setReadableFilter] = useState('all');
    const [load, setIsloading] = useState(true);
    const [lowerId, setLowerId] = useState(-1);
    const [upperID, setUpperId] = useState(-1);
    const [notifications, setNotifications] = useState([]);
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState(DEFAULT_FILTER);
    const { filteredData: filteredNotifications, searchQuery, onChangeSearchQuery } = useSearch({
        fields: [
            "text_en",
            'text_ar',
            'title_en',
            'title_ar',
        ],
        items: notifications
    });
    const memberId = (_a = getDataFromStorage().userInfo.id) !== null && _a !== void 0 ? _a : 0;
    useEffect(() => {
        if (!socket)
            return;
        socket.on('delta-end', function (data) {
            setLowerId(data.lower_id);
            setUpperId(data.upper_id);
            if (data.lower_id === 0) {
                setHasMore(false);
                setIsloading(false);
            }
            console.log('delta-end');
        });
        socket.on('timeline-notification', function (data) {
            console.log("timeline-notification");
            setNotifications(prevNotifications => {
                return [data, ...prevNotifications];
            });
        });
        socket.on('timeline-bulk-status', function (data) {
            socket === null || socket === void 0 ? void 0 : socket.emit('get-stats');
        });
        socket.emit('timeline-history', {
            "lower_id": upperID,
            "limit": LIMIT_HISTORY,
            "slice": true
        });
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('delta-updates');
            socket === null || socket === void 0 ? void 0 : socket.off('delta-end');
            socket === null || socket === void 0 ? void 0 : socket.off('timeline-notification');
            socket === null || socket === void 0 ? void 0 : socket.off('timeline-bulk-status');
        };
    }, [socket]);
    useEffect(() => {
        if (filteredNotifications.length < LIMIT_HISTORY && hasMore) {
            const debounce = setTimeout(() => fetchData(), 100);
            return () => {
                clearTimeout(debounce);
            };
        }
        return;
    }, [filteredNotifications, hasMore]);
    const setSearch = (text) => {
        onChangeSearchQuery(text);
    };
    const markAllAsRead = useCallback(() => {
        var _a, _b;
        if (!socket)
            return;
        const firstNotification = (_a = notifications[0]) !== null && _a !== void 0 ? _a : 0;
        const lastNotification = (_b = notifications[notifications.length - 1]) !== null && _b !== void 0 ? _b : 0;
        socket === null || socket === void 0 ? void 0 : socket.emit('timeline-set-bulk-status', {
            lower_id: 0,
            upper_id: firstNotification.timeline_id,
            status: EnumNotificationStatus.SEEN
        }, function (data) {
            socket === null || socket === void 0 ? void 0 : socket.emit('get-stats');
        });
        resetNotifications();
    }, [socket, notifications]);
    function fetchData() {
        socket === null || socket === void 0 ? void 0 : socket.emit('timeline-history', {
            upper_id: lowerId,
            limit: LIMIT_HISTORY,
            slice: true
        });
    }
    const filterReadHandler = useCallback((data) => {
        if (filter.read === FilterReadEnum.All) {
            return data;
        }
        return data.filter(item => {
            if (filter.read === FilterReadEnum.Read)
                return ReadStatus.includes(item.status);
            return !ReadStatus.includes(item.status);
        });
    }, [filter.read]);
    const filterTapHandler = useCallback((data) => {
        if (filter.tap === FilterTapEnum.All) {
            return data;
        }
        return data.filter(item => {
            if (filter.tap === FilterTapEnum.MyAds)
                return item.user_id === memberId;
            return item.user_id !== memberId;
        });
    }, [filter.tap]);
    const filterEventHandler = useCallback((notifications) => {
        notifications = filterTapHandler(notifications);
        notifications = filterReadHandler(notifications);
        return notifications;
    }, [filterTapHandler, filterReadHandler]);
    const resetNotifications = () => {
        setNotifications([]);
        setHasMore(true);
        setLowerId(-1);
        setUpperId(-1);
    };
    const onChangeReadFilter = (status) => setFilter((currentFilter) => {
        resetNotifications();
        return Object.assign(Object.assign({}, currentFilter), { read: status });
    });
    const onChangeTapFilter = (status) => setFilter((currentFilter) => {
        resetNotifications();
        return Object.assign(Object.assign({}, currentFilter), { tap: status });
    });
    useEffect(() => {
        if (!socket)
            return;
        setIsloading(true);
        socket.on('delta-inserts', function (data) {
            setIsloading(false);
            setNotifications(prevNotifications => {
                return [
                    ...filterEventHandler(prevNotifications),
                    ...filterEventHandler(data.inserts)
                ];
            });
        });
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('delta-inserts');
        };
    }, [socket, filterEventHandler]);
    const config = {
        actions: {
            filterNotification: onChangeReadFilter,
            onClickAllAdsButtonHandler: () => onChangeTapFilter(FilterTapEnum.All),
            onClickMyAdsButtonHandler: () => onChangeTapFilter(FilterTapEnum.MyAds),
            onClickOtherAdsButtonHandler: () => onChangeTapFilter(FilterTapEnum.OtherAds),
            onChangeListing: onChangeTapFilter,
            onChangeReadableFilter: onChangeReadFilter,
            onClickMarkAllButtonHandler: markAllAsRead,
            onSearchAds: (text) => setSearch(text)
        },
        states: {
            searchQuery
        }
    };
    const locales = {
        ar: {
            emptyNotification: "لا يوجد اشعارات"
        },
        en: {
            emptyNotification: "No Notifications"
        }
    };
    return (React.createElement(MainContainer, null,
        React.createElement("div", { className: "card" },
            React.createElement("div", { className: "card-header ps-3 pe-3" },
                React.createElement("div", { className: 'row w-100 align-items-center justify-content-between' },
                    React.createElement(HeaderComponent, { config: config, header: props.header }))),
            React.createElement("div", { className: "card-body pt-4 px-0" },
                React.createElement("div", { className: "tab-content px-9 hover-scroll-overlay-y pe-7 me-3 mb-2", id: "kt_list_widget_16_tab_1" },
                    React.createElement("div", { className: "tab-pane fade show active", role: "tabpanel", style: {
                            height: "80vh",
                        } },
                        React.createElement(InfiniteScroll, { style: { width: "100%", overflow: "inherit" }, dataLength: notifications.length, next: fetchData, hasMore: hasMore, loader: React.createElement("div", { className: "row p-5" },
                                React.createElement("div", { className: "col-lg-12 text-center" },
                                    React.createElement("div", { className: "spinner-border text-success", role: "status" },
                                        React.createElement("span", { className: "visually-hidden" })))), endMessage: filteredNotifications.length == 0 && React.createElement("div", { className: 'text-center p-2 mt-10' },
                                React.createElement("p", { className: 'p-0 m-0 fs-1' }, locales[useConfig().lang].emptyNotification),
                                React.createElement("br", null),
                                React.createElement("svg", { width: "201", height: "201", viewBox: "0 0 201 201", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                    React.createElement("rect", { width: "201", height: "201", fill: "white" }),
                                    React.createElement("path", { d: "M29 69C34.5228 69 39 64.5228 39 59C39 53.4772 34.5228 49 29 49C23.4772 49 19 53.4772 19 59C19 64.5228 23.4772 69 29 69Z", fill: "#E7EBF7" }),
                                    React.createElement("path", { d: "M42.5 171C45.5376 171 48 168.538 48 165.5C48 162.462 45.5376 160 42.5 160C39.4624 160 37 162.462 37 165.5C37 168.538 39.4624 171 42.5 171Z", fill: "#E7EBF7" }),
                                    React.createElement("path", { d: "M174.5 111C177.538 111 180 108.538 180 105.5C180 102.462 177.538 100 174.5 100C171.462 100 169 102.462 169 105.5C169 108.538 171.462 111 174.5 111Z", fill: "#E7EBF7" }),
                                    React.createElement("path", { d: "M115.309 149.597C115.309 140.538 107.954 133.194 98.8795 133.194C89.8052 133.194 82.4497 140.538 82.4497 149.597C82.4497 158.656 89.8052 166 98.8795 166C107.954 166 115.309 158.656 115.309 149.597V149.597Z", fill: "#F7C92B" }),
                                    React.createElement("path", { d: "M98.8795 133.194C97.2185 133.194 95.6154 133.442 94.1042 133.9C100.849 135.942 105.759 142.195 105.759 149.597C105.759 156.997 100.849 163.252 94.1042 165.294C95.6154 165.752 97.2185 166 98.8795 166C107.954 166 115.309 158.656 115.309 149.597C115.309 140.538 107.954 133.194 98.8795 133.194V133.194Z", fill: "#F2B51D" }),
                                    React.createElement("path", { d: "M100.799 53.8627C95.5223 54.9211 90.3863 51.5093 89.3258 46.2407C88.2652 40.9731 91.6834 35.8447 96.9595 34.7863C102.236 33.7279 107.373 37.1397 108.433 42.4083C109.493 47.6758 106.076 52.8043 100.799 53.8627Z", fill: "#8B94AA" }),
                                    React.createElement("path", { d: "M108.433 42.4083C107.373 37.1397 102.236 33.7279 96.9595 34.7863C96.4683 34.8847 95.9942 35.0196 95.5372 35.1844C98.6173 36.3103 101.056 38.9622 101.75 42.4083C102.712 47.1857 99.9893 51.8486 95.5383 53.4646C97.1672 54.0596 98.9747 54.2287 100.799 53.8627C106.076 52.8043 109.493 47.6758 108.433 42.4083Z", fill: "#81899B" }),
                                    React.createElement("path", { d: "M139.573 146.852H58.186C50.9033 146.852 45 140.958 45 133.689C45 129.664 46.8247 125.855 49.9625 123.328L52.5771 121.222C58.6248 116.352 62.1415 109.012 62.1415 101.255V87.4204C62.1415 67.0084 78.7147 50.4619 99.1599 50.4619C119.604 50.4619 136.178 67.0084 136.178 87.4204V101.511C136.178 109.121 139.563 116.339 145.418 121.213L147.964 123.332C151.003 125.861 152.759 129.607 152.759 133.556V133.689C152.759 140.958 146.856 146.852 139.573 146.852Z", fill: "#E9EDF5" }),
                                    React.createElement("path", { d: "M147.964 123.332L145.418 121.213C139.563 116.338 136.178 109.121 136.178 101.509V87.4189C136.178 67.008 119.604 50.4604 99.1598 50.4604C95.5372 50.4604 92.0376 50.9827 88.7296 51.9512C104.096 56.4472 115.318 70.6242 115.318 87.4189V101.509C115.318 109.121 118.703 116.338 124.558 121.213L127.105 123.332C130.142 125.861 131.9 129.606 131.9 133.555V133.688C131.9 140.958 125.996 146.852 118.714 146.852H139.574C146.856 146.852 152.759 140.958 152.759 133.688V133.555C152.759 129.606 151.003 125.861 147.964 123.332V123.332Z", fill: "#F1F4F8" }))), pullDownToRefresh: false, pullDownToRefreshThreshold: 100, pullDownToRefreshContent: null, releaseToRefreshContent: null, scrollableTarget: 'kt_list_widget_16_tab_1' },
                            React.createElement(Notifications, { load: load, notifications: filteredNotifications, setNotifications: setNotifications, NotificationItem: props.NotificationItem }))))))));
};
export default NotificationsPage;
